(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gridone-booking"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('gridone-booking')) {
    customElements.define('gridone-booking', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.controller = new AbortController();
        this.config = JSON.parse(this.querySelector('[data-gb-config]').textContent);
        this.text = this.config.text;
        this.state = { mode: 'solo', rig: 'gt', motion: false, minutes: 60, togetherCount: 2, groupCount: 4, groupRig: 'both', attack: false };
        this.key = 'gridone-booking:' + location.pathname + ':' + this.config.id;
        this.form = this.querySelector('.gb-contact-form');
        this.request = this.querySelector('[data-gb-request]');
        this.formType = this.querySelector('[data-gb-form-type]');
        this.formCount = this.querySelector('[data-gb-form-count]');
        this.date = this.querySelector('[data-gb-date]');
        this.time = this.querySelector('[data-gb-time]');
        this.opened = false;
        const otherForm = location.hash.startsWith('#GridoneInquiry-');
        if(otherForm) this.querySelector('[data-gb-success]')?.setAttribute('hidden','');
        const success = otherForm ? null : this.querySelector('[data-gb-success]');
        const errors = this.querySelector('[data-gb-errors]');
        if (!success) this.restore();
        else { try { sessionStorage.removeItem(this.key); } catch {} }
        if (!success) {
          const experience = new URLSearchParams(location.search).get('opplevelse');
          if (['solo', 'together', 'group'].includes(experience)) this.state.mode = experience;
          if (experience === 'dual') { this.state.mode = 'solo'; this.state.rig = 'both'; }
          if (experience === 'solo' && this.state.rig === 'both') this.state.rig = this.config.availability.gt ? 'gt' : 'formula';
        }
        this.date.min = this.osloNow().date;
        this.addEventListener('click', event => this.click(event), { signal: this.controller.signal });
        this.addEventListener('change', event => this.change(event), { signal: this.controller.signal });
        this.form.addEventListener('submit', event => this.submit(event), { signal: this.controller.signal });
        this.addEventListener('shopify:block:select', event => { if (this.request.contains(event.target) || event.target === this.request) { this.request.hidden = false; this.opened = true; } }, { signal: this.controller.signal });
        this.sync();
        this.setAttribute('data-ready', '');
        this.request.hidden = !(window.Shopify?.designMode || success || errors || location.hash === '#' + this.request.id);
        this.opened = !this.request.hidden;
        if (success || errors) {
          this.opened = true;
          requestAnimationFrame(() => { this.request.scrollIntoView({ block: 'start' }); (success || errors).focus({ preventScroll: true }); });
        }
      }
      disconnectedCallback() { this.controller?.abort(); this.ready = false; }
      q(selector) { return this.querySelector(selector); }
      qa(selector) { return this.querySelectorAll(selector); }
      money(value) { return new Intl.NumberFormat(this.config.locale, { style: 'currency', currency: 'NOK', maximumFractionDigits: 0 }).format(value); }
      discount(value) {
        const base = Math.max(0, Number(value) || 0);
        const saving = this.config.discountType === 'amount' ? Math.max(0, Number(this.config.discountAmount) || 0) : base * Math.max(0, Math.min(100, Number(this.config.discount) || 0)) / 100;
        return Math.max(0, Math.round(base - saving));
      }
      soloPrice(minutes, motion, both) {
        const primary = this.config.prices[motion ? 'motion' : 'base'][minutes];
        const secondary = both ? this.config.prices.base[minutes] : 0;
        return both && this.config.discountType === 'amount' ? this.discount(primary) + this.discount(secondary) : this.discount(primary + secondary);
      }
      renderPrice(element, raw, price) {
        element.replaceChildren();
        if (price < raw) {
          const old = document.createElement('s');
          old.className = 'gb-inline-before';
          old.textContent = this.money(raw);
          element.append(old, document.createTextNode(' '));
        }
        const current = document.createElement('span');
        current.className = price < raw ? 'gb-inline-sale' : '';
        current.textContent = this.money(price);
        element.append(current);
      }
      available(rig) { return rig === 'both' ? this.config.availability.gt && this.config.availability.formula : this.config.availability[rig]; }
      hours() { const day=new Date((this.date.value || this.osloNow().date)+'T12:00:00Z').getUTCDay();const c=this.config.schedule;return {start:day===0?c.sundayStart:day===6?c.saturdayStart:600,end:day===0?c.sundayEnd:day===6?c.saturdayEnd:day===5?c.fridayEnd:c.weekdayEnd}; }
      validTime(value, minutes) { if(!/^\d{2}:\d{2}$/.test(value)) return false; const [h,m]=value.split(':').map(Number);const start=h*60+m;const hours=this.hours();return start>=hours.start && start+(minutes || 120)<=hours.end && m<60 && m%15===0; }
      endTime(value,minutes){const [h,m]=value.split(':').map(Number);const end=h*60+m+minutes;return String(Math.floor(end/60)).padStart(2,'0')+':'+String(end%60).padStart(2,'0');}
      duration(value) {
        if (!value) return this.text.suggestion;
        const h = Math.floor(value / 60), m = value % 60;
        return [h ? h + ' ' + this.text.hour : '', m ? m + ' ' + this.text.minute : ''].filter(Boolean).join(' ');
      }
      osloNow() {
        const parts = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Oslo', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' }).formatToParts(new Date());
        const p = Object.fromEntries(parts.map(item => [item.type, item.value]));
        return { date: p.year + '-' + p.month + '-' + p.day, time: p.hour + ':' + p.minute };
      }
      restore() {
        try {
          const stored = JSON.parse(sessionStorage.getItem(this.key));
          if (!stored || Date.now() - stored.at > 7200000) return;
          const s = stored.state;
          if (['solo','together','group'].includes(s.mode)) this.state.mode = s.mode;
          if (['gt','formula','both'].includes(s.rig)) this.state.rig = s.rig;
          if ([30,60,90].includes(s.minutes)) this.state.minutes = s.minutes;
          if ([2,4,6].includes(s.togetherCount)) this.state.togetherCount = s.togetherCount;
          if (Number.isInteger(s.groupCount) && s.groupCount >= 2) this.state.groupCount = Math.min(20, s.groupCount);
          if (['gt','formula','both'].includes(s.groupRig)) this.state.groupRig = s.groupRig;
          this.state.motion = s.motion === true;
          this.state.attack = s.attack === true;
        } catch {}
      }
      snapshot() {
        const s = this.state, together = s.mode === 'together', group = s.mode === 'group';
        const rig = group ? s.groupRig : s.rig, motion = group || (rig !== 'formula' && s.motion);
        const count = group ? s.groupCount : together ? s.togetherCount : rig === 'both' ? 2 : 1;
        const minutes = group ? 0 : together ? this.config.durations[count] : s.minutes;
        const rawPrice = group ? null : together ? this.config.together[motion ? 'motion' : 'base'] * count : this.config.prices[motion ? 'motion' : 'base'][s.minutes] + (rig === 'both' ? this.config.prices.base[s.minutes] : 0);
        const price = group ? null : together ? this.discount(this.config.together[motion ? 'motion' : 'base']) * count : this.soloPrice(s.minutes, motion, rig === 'both');
        const rigName = rig === 'both' ? this.text.gt + ' · ' + (motion ? this.text.on : this.text.off) + ' / ' + this.text.formula + ' · ' + this.text.no_motion : this.text[rig] + ' · ' + (rig === 'formula' ? this.text.no_motion : motion ? this.text.on : this.text.off);
        return { together, group, rig, motion, count, minutes, price, rawPrice, rigName, duration: group ? '' : s.mode === 'solo' ? minutes + ' ' + this.text.minute : this.duration(minutes) };
      }
      sync() {
        const s = this.state;
        const fallback = this.config.availability.gt ? 'gt' : 'formula';
        if(!this.available(s.rig)) s.rig = fallback;
        s.groupRig = 'both';
        s.groupCount = Math.max(2, Math.min(20, Math.round(Number(s.groupCount) || 2)));
        if (s.mode === 'together' && s.rig === 'both') s.rig = fallback;
        if(![2,4,6].includes(s.togetherCount)) s.togetherCount=2;
        const unavailable = s.mode === 'group' ? !this.available('both') : !this.config.availability.gt && !this.config.availability.formula;
        this.q('[data-gb-unavailable]').hidden = !unavailable;
        this.qa('[data-gb-next],.gb-contact-form [type=submit]').forEach(el=>el.disabled=unavailable);
        this.qa('[data-gb-rig],[data-gb-rig-link]').forEach(el=>{ const ok=this.available(el.dataset.gbRig || el.dataset.gbRigLink);el.hidden=!ok;if(el.tagName==='BUTTON')el.disabled=!ok; });
        const v = this.snapshot();
        this.q('[data-gb-rig=both]').hidden = s.mode !== 'solo' || !this.available('both');
        this.q('[data-gb-dual]').hidden = !(s.mode === 'solo' && v.rig === 'both');
        this.qa('[data-gb-together]').forEach(el => el.hidden = !v.together);
        this.qa('[data-gb-group]').forEach(el => el.hidden = !v.group);
        this.qa('[data-gb-other],[data-gb-time-field],[data-gb-hours-note],[data-gb-duration-field],[data-gb-summary-time-row]').forEach(el => el.hidden = v.group);
        this.time.disabled = v.group;
        this.time.required = !v.group;
        this.time.setCustomValidity('');
        this.q('[data-gb-form-duration]').disabled = v.group;
        this.q('[data-gb-fixed-rigs]').hidden = v.group;
        this.q('[data-gb-solo-times]').hidden = s.mode !== 'solo';
        this.q('[data-gb-motion-wrap]').hidden = v.group || v.rig === 'formula';
        this.qa('[data-gb-mode]').forEach(el => el.setAttribute('aria-pressed', String(el.dataset.gbMode === s.mode)));
        this.qa('[data-gb-rig]').forEach(el => el.setAttribute('aria-pressed', String(el.dataset.gbRig === s.rig)));
        this.qa('[data-gb-minutes]').forEach(el => el.setAttribute('aria-pressed', String(Number(el.dataset.gbMinutes) === s.minutes)));
        this.q('[data-gb-together-count]').value = String(s.togetherCount);
        this.q('[data-gb-group-count]').value = String(s.groupCount);
        this.q('[data-gb-comment-help]').hidden = !v.group;
        this.q('[data-gb-comment-custom]').hidden = !v.group;
        this.q('[data-gb-comment-default]').hidden = v.group;
        this.q('textarea[name="contact[body]"]').required = v.group;
        this.q('[data-gb-motion]').checked = s.motion;
        this.q('[data-gb-timeattack]').checked = s.attack;
        this.qa('[data-gb-slot-price]').forEach(el => {
          const minutes = el.dataset.gbSlotPrice, both = s.mode === 'solo' && v.rig === 'both';
          const raw = this.config.prices[v.motion ? 'motion' : 'base'][minutes] + (both ? this.config.prices.base[minutes] : 0);
          this.renderPrice(el, raw, this.soloPrice(minutes, v.motion, both));
        });
        this.qa('[data-gb-duration-row]').forEach(el => el.textContent = this.duration(this.config.durations[el.dataset.gbDurationRow]));
        this.q('[data-gb-timing]').textContent = this.config.timing[s.togetherCount] || '';
        this.q('[data-gb-auto-time]').textContent = this.duration(this.config.durations[s.togetherCount]);
        this.q('[data-gb-summary-rig]').textContent = v.rigName;
        this.q('[data-gb-summary-count]').textContent = v.count + ' ' + (v.count === 1 ? this.text.person : this.text.people);
        this.q('[data-gb-summary-time-label]').textContent = s.mode === 'solo' ? this.text.driving : this.text.visit;
        this.q('[data-gb-summary-time]').textContent = v.duration;
        this.q('[data-gb-total]').hidden = false;
        this.q('[data-gb-next-label]').textContent = v.group ? this.text.group_next_label : this.text.next_label;
        this.q('[data-gb-total]').classList.toggle('gb-total--quote', v.group);
        this.qa('.gb-campaign,.gb-promo').forEach(el => el.hidden = v.group);
        this.q('[data-gb-price-note]').hidden = false;
        this.q('.gb-price-list').hidden = v.group;
        this.qa('[data-gb-price-solo]').forEach(el => el.hidden = v.together);
        this.qa('[data-gb-price-together]').forEach(el => el.hidden = !v.together);
        this.qa('[data-gb-together-price]').forEach(el => { const base = this.config.together[el.dataset.gbTogetherPrice], count = Number(el.dataset.count); this.renderPrice(el, base * count, this.discount(base) * count); });
        this.qa('[data-gb-together-price-row]').forEach(el => { const active = Number(el.dataset.gbTogetherPriceRow) === v.count; el.classList.toggle('gb-current-row', active); if(active)el.setAttribute('aria-current','true');else el.removeAttribute('aria-current'); });
        this.q('[data-gb-price-field]').hidden = v.group;
        this.q('[data-gb-form-price]').disabled = v.group;
        this.q('[data-gb-total]').textContent = v.price === null ? this.text.quote : this.money(v.price);
        this.q('[data-gb-price-note]').textContent = v.group ? this.text.quote_note : v.together ? this.money(v.price / v.count) + ' ' + this.text.per_person + ' × ' + v.count + '. ' + this.text.package_note : this.text.total_note;
        this.formType.value = this.text[s.mode];
        this.formCount.value = String(v.count);
        this.formCount.min = s.mode === 'solo' ? String(v.count) : '2';
        this.formCount.max = v.group ? '20' : v.together ? '6' : String(v.count);
        this.formCount.step = v.together ? '2' : '1';
        this.formCount.readOnly = s.mode === 'solo';
        this.qa('.gb-stepper').forEach(wrap => { const input = wrap.querySelector('input'); wrap.querySelector('[data-gb-step="-1"]').disabled = input.readOnly || Number(input.value) <= Number(input.min); wrap.querySelector('[data-gb-step="1"]').disabled = input.readOnly || Number(input.value) >= Number(input.max); });
        this.q('[data-gb-form-setup]').value = v.rigName;
        this.q('[data-gb-form-duration]').value = v.group ? '' : (s.mode === 'solo' ? this.text.driving : this.text.visit) + ': ' + v.duration;
        this.q('[data-gb-form-price]').value = v.price === null ? '' : this.money(v.price) + ' · ' + (v.group ? this.text.quote_note : this.text.total_note);
        this.q('[data-gb-form-attack]').value = (v.together || (v.group && s.attack)) ? this.text.yes : this.text.no;
        this.qa('[data-gb-static-price]').forEach(el => { const raw = Number(el.dataset.gbStaticPrice); this.renderPrice(el, raw, this.discount(raw)); });
        const hasDiscount = !v.group && v.price < v.rawPrice;
        const oldPrice=this.q('[data-gb-original]'); oldPrice.hidden = !hasDiscount; oldPrice.textContent=v.rawPrice===null?'':this.money(v.rawPrice);
        const badgeValue = this.config.discountType === 'amount' ? this.money(v.rawPrice - v.price) : Math.max(0,Math.min(100,Number(this.config.discount)||0)) + '%';
        const badge = this.q('[data-gb-sale-badge]'); badge.hidden = !hasDiscount; badge.textContent = (this.config.discountBadge || '−[value]').replaceAll('[value]', badgeValue);
        this.q('[data-gb-price-campaign]').hidden = !hasDiscount;
        this.q('[data-gb-saving]').hidden = !hasDiscount;
        this.q('[data-gb-saved-amount]').textContent = hasDiscount ? this.money(v.rawPrice-v.price) : '';
        this.q('[data-gb-total]').classList.toggle('gb-sale-price',hasDiscount);
        if (!v.group) {
        const selectedTime=this.time.value;
        const placeholder=this.time.options[0].cloneNode(true);
        const options=[placeholder];
        const now=this.osloNow();
        const hours=this.hours();
        for(let start=hours.start;start+(v.minutes || 120)<=hours.end;start+=15){
          const value=String(Math.floor(start/60)).padStart(2,'0')+':'+String(start%60).padStart(2,'0');
          if(this.date.value===now.date && value<=now.time)continue;
          options.push(new Option(v.minutes ? value+'–'+this.endTime(value,v.minutes) : value,value));
        }
        this.time.replaceChildren(...options);
        this.q('[data-gb-no-times]').hidden=options.length>1;
        this.time.value=options.some(o=>o.value===selectedTime)?selectedTime:'';
        } else { this.q('[data-gb-no-times]').hidden = true; }
        this.q('[data-gb-form-summary]').textContent = [this.text[s.mode], v.rigName, v.count + ' ' + (v.count === 1 ? this.text.person : this.text.people), v.duration, v.price === null ? '' : this.money(v.price), v.group ? this.text.quote_note : ''].filter(Boolean).join(' · ');
      }
      click(event) {
        const step = event.target.closest('[data-gb-step]');
        if(step && this.contains(step)){ event.preventDefault(); const input = step.closest('.gb-stepper').querySelector('input'); if(input.readOnly)return; input.value=String(Math.max(Number(input.min),Math.min(Number(input.max),Number(input.value)+Number(step.dataset.gbStep)*Number(input.step || 1)))); input.dispatchEvent(new Event('change',{bubbles:true})); return; }
        const el = event.target.closest('[data-gb-mode],[data-gb-start],[data-gb-rig],[data-gb-rig-link],[data-gb-minutes],[data-gb-next],[data-gb-edit]');
        if (!el || !this.contains(el)) return;
        event.preventDefault();
        if (el.hasAttribute('data-gb-next') && this.state.mode === 'group' && !this.validGroup()) return;
        if (el.hasAttribute('data-gb-mode') || el.hasAttribute('data-gb-start')) this.state.mode = el.dataset.gbMode || el.dataset.gbStart;
        if (el.hasAttribute('data-gb-rig')) this.state.rig = el.dataset.gbRig;
        if (el.hasAttribute('data-gb-rig-link')) { this.state.mode = 'solo'; this.state.rig = el.dataset.gbRigLink; }
        if (el.hasAttribute('data-gb-minutes')) this.state.minutes = Number(el.dataset.gbMinutes);
        this.sync();
        if (el.hasAttribute('data-gb-next')) {
          this.request.hidden = false; this.opened = true;
          this.request.scrollIntoView({ block: 'start', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
          this.q('input[autocomplete="given-name"]').focus({ preventScroll: true });
        } else if (el.hasAttribute('data-gb-start') || el.hasAttribute('data-gb-rig-link') || el.hasAttribute('data-gb-edit')) this.q('.gb-config').scrollIntoView({ block: 'start' });
      }
      change(event) {
        const el = event.target, s = this.state;
        if (el.matches('[data-gb-date],[data-gb-time]')) { this.time.setCustomValidity(''); if(el.matches('[data-gb-date]'))this.sync(); return; }
        if (el.matches('[data-gb-together-count]')) s.togetherCount = Number(el.value);
        else if (el.matches('[data-gb-group-count]')) { if (!el.checkValidity()) return; s.groupCount = Number(el.value); }
        else if (el.matches('[data-gb-form-count]')) { if (!el.checkValidity()) return; if (s.mode === 'together') s.togetherCount = Number(el.value); if (s.mode === 'group') s.groupCount = Number(el.value); }
        else if (el.matches('[data-gb-motion]')) s.motion = el.checked;
        else if (el.matches('[data-gb-timeattack]')) s.attack = el.checked;
        else return;
        this.sync();
      }
      validGroup() {
        if (!this.q('[data-gb-group-count]').reportValidity()) return false;
        return true;
      }
      submit(event) {
        if (this.state.mode === 'group' && !this.validGroup()) { event.preventDefault(); this.q('.gb-config').scrollIntoView({block:'start'}); return; }
        const v = this.snapshot();
        if (!this.available(v.rig)) { event.preventDefault(); return; }
        if (!v.group && !this.validTime(this.time.value,v.minutes)) { event.preventDefault(); this.time.setCustomValidity(this.text.past_time); this.time.reportValidity(); return; }
        const now = this.osloNow();
        this.date.min = now.date;
        if (!this.date.reportValidity()) { event.preventDefault(); return; }
        if (this.date.value < now.date || (!v.group && this.date.value === now.date && this.time.value <= now.time)) {
          event.preventDefault(); this.time.setCustomValidity(this.text.past_time); this.time.reportValidity(); return;
        }
        this.time.setCustomValidity('');
        const count = Number(this.formCount.value);
        if (!this.formCount.checkValidity()) { event.preventDefault(); this.formCount.reportValidity(); return; }
        if (this.state.mode === 'together') this.state.togetherCount = count;
        if (this.state.mode === 'group') this.state.groupCount = count;
        this.sync();
        this.q('[data-gb-name]').value=[this.q('input[name="contact[Fornavn]"]').value,this.q('input[name="contact[Etternavn]"]').value].join(' ').trim();
        this.q('[data-gb-reference]').value='GRID-'+Date.now().toString(36).toUpperCase();
        const body=this.q('textarea[name="contact[body]"]');
        const summary=this.q('[data-gb-form-summary]').textContent+'\n'+this.date.value+(v.group ? '' : ' '+this.time.value+'–'+this.endTime(this.time.value,v.minutes));
        body.value=summary+(body.value.trim()?'\n\n'+body.value.trim():'');
        try { sessionStorage.setItem(this.key, JSON.stringify({ at: Date.now(), state: this.state })); } catch {}
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gridone-inquiry"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('gridone-inquiry'))customElements.define('gridone-inquiry',class extends HTMLElement{
 connectedCallback(){if(this.ready)return;this.ready=true;this.controller=new AbortController();
 const subject=this.querySelector('[data-gi-subject]'),success=this.querySelector('[data-gi-success]'),error=this.querySelector('[data-gi-error]');
 if((success||error)&&location.hash.startsWith('#GridoneBookingForm-')){this.hidden=true;return;}
 const reveal=(focus=false)=>{this.setAttribute('data-open','');this.hidden=false;document.querySelectorAll('a[href="#'+this.id+'"]').forEach(a=>{a.setAttribute('aria-controls',this.id);a.setAttribute('aria-expanded','true');});if(focus)requestAnimationFrame(()=>{this.scrollIntoView({block:'start'});const heading=this.querySelector('h2');heading?.setAttribute('tabindex','-1');heading?.focus({preventScroll:true});});};
 const matchesHash=()=>location.hash==='#'+this.id || location.hash==='#'+this.querySelector('form')?.id;
 if(success||error||matchesHash()||window.Shopify?.designMode)reveal();
 document.querySelectorAll('a[href="#'+this.id+'"]').forEach(a=>{a.setAttribute('aria-controls',this.id);a.setAttribute('aria-expanded',String(this.hasAttribute('data-open')));});
 document.addEventListener('click',event=>{const a=event.target.closest('a[href="#'+this.id+'"]');if(a)reveal(true);},{signal:this.controller.signal});
 window.addEventListener('hashchange',()=>{if(matchesHash())reveal();},{signal:this.controller.signal});
 document.addEventListener('shopify:section:select',event=>{if(event.detail?.sectionId===this.dataset.sectionId)reveal();},{signal:this.controller.signal});
 if(success||error)requestAnimationFrame(()=>{(success||error).scrollIntoView({block:'center'});(success||error).focus({preventScroll:true});});

 this.querySelector('form')?.addEventListener('submit',()=>{const ref=this.querySelector('[data-gi-reference]');if(ref)ref.value='GRID-'+Date.now().toString(36).toUpperCase();const body=this.querySelector('textarea[name="contact[body]"]');if(body&&!body.value.trim())body.value=(subject?.value||'Forespørsel')+(this.querySelector('[data-gi-amount]')?' · '+this.querySelector('[data-gi-amount]').value+' NOK':'');},{signal:this.controller.signal});
 const params=new URLSearchParams(location.search),interest=params.get('interesse');if(interest&&subject)subject.value=interest.slice(0,200);if(this.dataset.giftEnabled==='true'){ if(subject)subject.value=this.dataset.giftLabel; }
 }
 disconnectedCallback(){this.controller?.abort();this.ready=false;}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gridone-reviews"]) return;
  try {
    
if(!customElements.get('gridone-reviews'))customElements.define('gridone-reviews',class extends HTMLElement{
 connectedCallback(){if(this.controller)return;this.controller=new AbortController();const signal=this.controller.signal;const button=this.querySelector('[data-gr-toggle]');button?.addEventListener('click',()=>{const paused=this.dataset.paused!=='true';this.dataset.paused=String(paused);button.setAttribute('aria-pressed',String(paused));button.textContent=paused?button.dataset.play:button.dataset.pause;},{signal});this.addEventListener('shopify:block:select',event=>{this.dataset.paused='true';event.target.scrollIntoView({block:'nearest',inline:'center'});},{signal});}
 disconnectedCallback(){this.controller?.abort();this.controller=null;}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gridone-simgrade-feature"] && !Shopify.designMode) return;
  try {
    
(() => {
  function initVideos() {
    document.querySelectorAll('.gsf-video').forEach(video => {
      if (video.dataset.gsfReady) return;
      video.dataset.gsfReady = 'true';
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      const saveData = navigator.connection && navigator.connection.saveData;
      let visible = false;
      video.muted = true;
      video.volume = 0;
      video.removeAttribute('controls');
      const syncPlayback = () => {
        if (visible && !document.hidden && !reduced.matches && !saveData) video.play().catch(() => {});
        else video.pause();
      };
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(entries => {
          visible = entries.some(entry => entry.isIntersecting);
          syncPlayback();
        }, { threshold: 0.2 });
        observer.observe(video);
      }
      reduced.addEventListener('change', syncPlayback);
      document.addEventListener('visibilitychange', syncPlayback);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initVideos, { once: true });
  else initVideos();
  document.addEventListener('shopify:section:load', initVideos);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gridone-training"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('gridone-training'))customElements.define('gridone-training',class extends HTMLElement{
connectedCallback(){
 if(this.controller)return;this.controller=new AbortController();
 const config=JSON.parse(this.querySelector('[data-gtc-config]').textContent);
 const status=this.querySelector('[data-gtc-status]');
 if(status)requestAnimationFrame(()=>{status.scrollIntoView({block:'center'});status.focus({preventScroll:true});});
 const date=this.querySelector('[data-gtc-date]');if(!date)return;
 const mode=this.querySelector('[data-gtc-mode]');
 const gift=()=>mode?.value==='Gavekort';
 const syncMode=()=>{const active=gift();this.querySelector('[data-gtc-session-heading]').hidden=active;this.querySelector('[data-gtc-gift-heading]').hidden=!active;this.querySelector('[data-gtc-session-schedule]').hidden=active;this.querySelector('[data-gtc-session-note]').hidden=active;date.disabled=active;date.required=!active;date.setCustomValidity('');this.querySelector('[data-gtc-error]').textContent='';this.querySelector('[data-gtc-date-label]').hidden=active;this.querySelector('[data-gtc-time-label]').hidden=active;this.querySelector('input[name="contact[Klokkeslett]"]').disabled=active;const recipient=this.querySelector('[data-gtc-recipient]');if(recipient){recipient.disabled=!active;this.querySelector('[data-gtc-recipient-label]').hidden=!active;this.querySelector('[data-gtc-gift-note]').hidden=!active;}};
 if(mode){mode.addEventListener('change',syncMode,{signal:this.controller.signal});syncMode();}
 this.querySelector('[data-gtc-gift]')?.addEventListener('click',()=>{if(!mode)return;mode.value='Gavekort';syncMode();mode.scrollIntoView({block:'center',behavior:'smooth'});mode.focus({preventScroll:true});},{signal:this.controller.signal});
 const blocked=new Set(config.blocked.split(/[\s,;]+/).filter(Boolean));
 const nowParts=()=>Object.fromEntries(new Intl.DateTimeFormat('en-CA',{timeZone:'Europe/Oslo',year:'numeric',month:'2-digit',day:'2-digit',hour:'2-digit',minute:'2-digit',hourCycle:'h23'}).formatToParts(new Date()).map(p=>[p.type,p.value]));
 const now=nowParts(),today=now.year+'-'+now.month+'-'+now.day;
 const max=new Date(today+'T12:00:00Z');max.setUTCDate(max.getUTCDate()+Number(config.daysAhead||90));
 date.min=today;date.max=max.toISOString().slice(0,10);
 const validate=()=>{
  if(gift())return true;
  const value=date.value,p=nowParts(),current=p.year+'-'+p.month+'-'+p.day;
  const day=value?new Date(value+'T12:00:00Z').getUTCDay():NaN;
  const valid=!!value&&value>=current&&value<=date.max&&day>=1&&day<=5&&!blocked.has(value)&&!(value===current&&Number(p.hour)>=10);
  date.setCustomValidity(!value?'':valid?'':config.invalid);
  this.querySelector('[data-gtc-error]').textContent=value&&!valid?config.invalid:'';
  return valid;
 };
 date.addEventListener('change',validate,{signal:this.controller.signal});
 this.querySelector('form').addEventListener('submit',event=>{
  if(!validate()){event.preventDefault();date.reportValidity();return;}
  this.querySelector('[data-gtc-reference]').value='TRAIN-'+Date.now().toString(36).toUpperCase();
  const body=this.querySelector('textarea[name="contact[body]"]');
  if(!body.value.trim())body.value=this.querySelector('input[name="contact[Trening]"]').value+(gift()?' · '+mode.options[mode.selectedIndex].text:' · '+date.value+' · 10:00–11:30');
 },{signal:this.controller.signal});
}
disconnectedCallback(){this.controller?.abort();this.controller=null;}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gridone-turnkey-inquiry"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('gridone-turnkey-inquiry'))customElements.define('gridone-turnkey-inquiry',class extends HTMLElement{
 connectedCallback(){if(this.ready)return;this.ready=true;this.controller=new AbortController();
 const subject=this.querySelector('[data-gi-subject]'),success=this.querySelector('[data-gi-success]'),error=this.querySelector('[data-gi-error]');
 if((success||error)&&location.hash.startsWith('#GridoneBookingForm-')){this.hidden=true;return;}
 const reveal=(focus=false)=>{this.setAttribute('data-open','');this.hidden=false;document.querySelectorAll('a[href="#'+this.id+'"]').forEach(a=>{a.setAttribute('aria-controls',this.id);a.setAttribute('aria-expanded','true');});if(focus)requestAnimationFrame(()=>{this.scrollIntoView({block:'start'});const heading=this.querySelector('h2');heading?.setAttribute('tabindex','-1');heading?.focus({preventScroll:true});});};
 const matchesHash=()=>location.hash==='#'+this.id || location.hash==='#'+this.querySelector('form')?.id;
 if(success||error||matchesHash()||window.Shopify?.designMode)reveal();
 document.querySelectorAll('a[href="#'+this.id+'"]').forEach(a=>{a.setAttribute('aria-controls',this.id);a.setAttribute('aria-expanded',String(this.hasAttribute('data-open')));});
 document.addEventListener('click',event=>{const a=event.target.closest('a[href]');if(!a)return;const target=new URL(a.href,location.href);if(target.origin===location.origin&&target.pathname===location.pathname&&target.hash==='#'+this.id){const model=a.dataset.simulatorModel||(target.searchParams.get('modell')?'GRID.ONE '+target.searchParams.get('modell'):'');if(subject)subject.value=model||this.dataset.defaultSubject;reveal(true);}},{signal:this.controller.signal,capture:true});
 window.addEventListener('hashchange',()=>{if(matchesHash())reveal();},{signal:this.controller.signal});
 document.addEventListener('shopify:section:select',event=>{if(event.detail?.sectionId===this.dataset.sectionId)reveal();},{signal:this.controller.signal});
 if(success||error)requestAnimationFrame(()=>{(success||error).scrollIntoView({block:'center'});(success||error).focus({preventScroll:true});});

 this.querySelector('form')?.addEventListener('submit',()=>{const ref=this.querySelector('[data-gi-reference]');if(ref)ref.value='GRID-'+Date.now().toString(36).toUpperCase();const body=this.querySelector('textarea[name="contact[body]"]');if(body&&!body.value.trim())body.value=(subject?.value||'Forespørsel')+(this.querySelector('[data-gi-amount]')?' · '+this.querySelector('[data-gi-amount]').value+' NOK':'');},{signal:this.controller.signal});
 const params=new URLSearchParams(location.search),interest=params.get('modell')||params.get('produkt')||params.get('interesse');if(interest&&subject){subject.value=interest.slice(0,200);if(['Sprint','Trophy','Clubsport','Ultimate','Custom'].includes(subject.value))subject.value='GRID.ONE '+subject.value;}if(this.dataset.giftEnabled==='true'){ if(subject)subject.value=this.dataset.giftLabel; }
 }
 disconnectedCallback(){this.controller?.abort();this.ready=false;}
});

  } catch(e) { console.error(e); }
})();
})();
